import styled from 'styled-components';
import { Result } from 'antd';

export const StyledResult = styled(Result)`
  padding-top: 4.5em;
`;
